var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { isEqual } from 'lodash';
import { Button } from '@mui/material';
export var AutocompleteDropdown = React.forwardRef(function (props, ref) {
    var options = props.options, totalOptions = props.totalOptions, allowSelectAll = props.allowSelectAll, onSelectAllClick = props.onSelectAllClick, selectedOptions = props.selectedOptions, filteredOptions = props.filteredOptions, children = props.children, listProps = __rest(props, ["options", "totalOptions", "allowSelectAll", "onSelectAllClick", "selectedOptions", "filteredOptions", "children"]);
    var blurAllOptions = function () {
        document.querySelectorAll("#" + listProps.id + " .Mui-focused").forEach(function (elm) { return elm.classList.remove('Mui-focused'); });
    };
    var isOptionSelected = function (option) { return selectedOptions.findIndex(function (selected) { return isEqual(selected, option); }) !== -1; };
    var areAllVisibleSelected = filteredOptions.every(isOptionSelected);
    return React.createElement("ul", __assign({}, listProps, { ref: ref, className: "autocompleteSelector__options " + (allowSelectAll ? 'autocompleteSelector--allowSelectAll' : '') + " " + listProps.className }),
        children,
        totalOptions !== undefined && totalOptions > options.length && (React.createElement("li", { className: "MuiAutocomplete-option autocompleteSelector__xMoreResults", "aria-disabled": true },
            totalOptions - options.length,
            " more results")),
        allowSelectAll && (React.createElement("li", { className: "autocompleteSelector__selectAll" },
            React.createElement(Button, { onClick: function () { return onSelectAllClick(filteredOptions, areAllVisibleSelected); }, onMouseEnter: blurAllOptions },
                areAllVisibleSelected ? "Deselect all visible" : 'Select all visible',
                " (",
                filteredOptions.length,
                ")"))));
});
//# sourceMappingURL=AutocompleteDropdown.js.map